query UserRoles {
  availableRoles {
    id
    description
    tenantId
    tenantName
    isAdministrator
    isProjectSupervisor
    isPreferred
  }
}
